import { useMutation } from '@tanstack/react-query';

import { createAnvaTask } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { CreateTaskVariablesAnva } from '../types';

export default function useCreateTaskAnva() {
  return useMutation({
    mutationFn: ({ crmPartyId, ...task }: CreateTaskVariablesAnva) =>
      createAnvaTask(
        {
          params: {
            path: { anva_party_id: crmPartyId },
            query: {},
          },
          body: {
            title: task.title,
            description: task.description,
            priority: task.priority,
            anva_policy_id: task.crmPolicyId ?? undefined,
            due_date: task.dueDate ?? undefined,
            assigned_to: task.assignedTo ?? undefined,
            reason: task.reason ?? undefined,
            contact_person_name: task.contactPersonName ?? undefined,
            contact_person_email: task.contactPersonEmail ?? undefined,
          },
        },
        wgApi,
      ),
  });
}
